import { render, staticRenderFns } from "./ScreeningTimeChart.vue?vue&type=template&id=f55d10e6&scoped=true&"
import script from "./ScreeningTimeChart.vue?vue&type=script&lang=js&"
export * from "./ScreeningTimeChart.vue?vue&type=script&lang=js&"
import style0 from "./ScreeningTimeChart.vue?vue&type=style&index=0&id=f55d10e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f55d10e6",
  null
  
)

export default component.exports